import React, { useEffect, useState } from "react";
import axios from "axios";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const PayPalCheckout = ({ apiBase, paystubId, onPaid }) => {
  const [config, setConfig] = useState(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    axios.get(`${apiBase}/paypal/config`).then(({ data }) => setConfig(data)).catch(() => {
      toast.error("Could not load PayPal. Please refresh.");
    });
  }, [apiBase]);

  if (!config) {
    return (
      <div className="flex items-center justify-center py-8 text-[#64748B]">
        <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Loading PayPal…
      </div>
    );
  }

  return (
    <div data-testid="paypal-checkout">
      <PayPalScriptProvider
        options={{
          clientId: config.client_id,
          currency: "USD",
          intent: "capture",
          components: "buttons",
          "enable-funding": "card",
          "disable-funding": "paylater,credit",
        }}
      >
        {processing && (
          <div className="flex items-center justify-center pb-3 text-sm text-[#1E40AF]">
            <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Confirming payment…
          </div>
        )}
        <PayPalButtons
          style={{ layout: "vertical", color: "blue", shape: "pill", label: "paypal", tagline: false }}
          createOrder={async () => {
            const { data } = await axios.post(`${apiBase}/paypal/orders`, { paystub_id: paystubId });
            return data.id;
          }}
          onApprove={async (data) => {
            setProcessing(true);
            try {
              const { data: cap } = await axios.post(
                `${apiBase}/paypal/orders/${data.orderID}/capture`,
                { paystub_id: paystubId }
              );
              if (cap.status === "COMPLETED") {
                toast.success("Payment complete! Your statement is ready.");
                onPaid();
              } else {
                toast.error("Payment could not be confirmed.");
              }
            } catch (e) {
              toast.error(e?.response?.data?.detail || "Payment could not be completed.");
            } finally {
              setProcessing(false);
            }
          }}
          onError={() => toast.error("A PayPal error occurred. Please try again.")}
          onCancel={() => toast("Payment canceled. You can try again when ready.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};
